export default __webpack_public_path__ + "static/news_ewh_teaser-226eff0ce06ef1f048ffd03d0d91ba56.png";